export function PrivacyNote() {
  return (
    <p className="privacy-note">
      Usa el ejemplo incluido o carga datos propios. Todos los eventos son sintéticos: se generan en
      tu navegador y solo se envían al Worker de esta demo para validarlos y guardarlos con
      caducidad de 7 días. Nunca se procesan datos reales de terceros.
    </p>
  );
}
